import type { Catalog } from "../../en";

/** Filipino: Leads → Bookings view (mirrors en/engage/bookings.ts). */
export const bookings: Catalog["engage"]["bookings"] = {
  title: "Mga booking",
  tabs: {
    label: "I-filter ang mga booking ayon sa status",
    all: "Lahat",
    requested: "Hiniling",
    confirmed: "Kumpirmado",
    declined: "Tinanggihan",
    cancelled: "Kinansela",
  },
  waiting_one: "{{count}} request ang naghihintay ng sagot mo.",
  waiting_other: "{{count}} request ang naghihintay ng sagot mo.",
  showRequested: "Ipakita ang mga request",
  columns: {
    when: "Kailan",
    service: "Serbisyo",
    visitor: "Bisita",
    owner: "May-ari",
    status: "Status",
    actions: "Mga aksyon",
  },
  visitorTime: "Oras ng bisita: {{time}} ({{zone}})",
  party_one: "{{count}} tao",
  party_other: "{{count}} tao",
  phoneEnding: "Telepono na nagtatapos sa {{digits}}",
  note: "Tala: {{note}}",
  decisionNote: "Tala mo: {{note}}",
  status: {
    requested: "Hiniling",
    confirmed: "Kumpirmado",
    declined: "Tinanggihan",
    cancelled: "Kinansela",
    pending: "Nire-reserve",
    failed: "Pumalya",
  },
  mode: {
    calendar: "Na-book sa Google Calendar",
    request: "Request",
  },
  openCalendar: "Buksan sa Google Calendar",
  joinMeet: "Google Meet link",
  openLead: "Buksan ang lead",
  confirm: "Kumpirmahin",
  decline: "Tanggihan",
  confirmLabel: "Kumpirmahin ang booking ni {{name}}",
  declineLabel: "Tanggihan ang booking ni {{name}}",
  cancel: "Kanselahin ang booking",
  cancelLabel: "Kanselahin ang booking ni {{name}}",
  decision: {
    confirmTitle: "Kumpirmahin ang booking na ito?",
    declineTitle: "Tanggihan ang booking na ito?",
    confirmBody: "{{name}} · {{when}}. Makakatanggap ang bisita ng email ng kumpirmasyon.",
    declineBody: "{{name}} · {{when}}. Makakatanggap ang bisita ng email na hindi available ang oras na ito.",
    noteLabel: "Tala (opsyonal)",
    confirmHint: "Naka-save sa booking. Hindi ito ipinapadala sa bisita.",
    declineHint: "Kasama sa email sa bisita, kaya panatilihing magalang.",
    tooLong: "Panatilihing wala pang {{count}} character ang tala.",
    submitConfirm: "Kumpirmahin ang booking",
    submitDecline: "Tanggihan ang booking",
    cancelTitle: "Kanselahin ang booking na ito?",
    cancelBody: "{{name}} · {{when}}. Mababakante ang oras, aalisin ang event sa Google Calendar kung mayroon, at makakatanggap ang bisita ng email.",
    cancelHint: "Kasama sa email sa bisita, kaya panatilihing magalang.",
    submitCancel: "Kanselahin ang booking",
    keep: "Panatilihin ang booking",
  },
  confirmed: "Nakumpirma ang booking ni {{name}}",
  declined: "Tinanggihan ang booking ni {{name}}",
  cancelled: "Kinansela ang booking ni {{name}}",
  readOnly: "Makikita mo ang mga booking. Kailangan ng pahintulot na mag-edit ng lead para kumpirmahin, tanggihan, o kanselahin ang mga ito.",
  empty: {
    title: "Wala pang booking",
    filtered: "Walang {{status}} na booking",
    body: "Kapag nag-book ang assistant ng pagbisita o appointment, lalabas ito rito. Itakda ang oras ng bukas sa isang booking action para maalukan ng oras ang mga bisita.",
    filteredBody: "Subukan ang ibang status para makakita ng iba pa.",
    cta: "I-set up ang availability",
    showAll: "Ipakita ang lahat ng booking",
  },
  loadError: "Hindi ma-load ang mga booking.",
  showing: "Ipinapakita ang {{shown}} booking",
};
